import { useMemo } from 'react'
import { ETenderStatus, ITender } from 'types/tender'
import { TFunction } from 'i18next'
import { TenderTabValues } from 'pages/tender-participation/tender-participation'

export const useGetTenderTabs = (
  tender: ITender,
  t: TFunction,
  isTenderAuthority: boolean = false
) => {
  const tabs = useMemo(() => {
    const isEvaluationSubmitted =
      tender.status === ETenderStatus.EVALUATION_SUBMITTED
    const isUnderEvaluation = tender.status === ETenderStatus.UNDER_EVALUATION

    const isSpecialTenderStatus = [
      ETenderStatus.COMMITTEE_REVIEW,
      ETenderStatus.COMMITTEE_EVALUATION,
      ETenderStatus.COMPLETED,
      ETenderStatus.CONTRACT,
      ETenderStatus.COMMISSION_EVALUATION,
      ETenderStatus.WINNER_SELECTED,
      ETenderStatus.CANCELLED,
    ].includes(tender.status)

    const showCommonSideSections =
      isSpecialTenderStatus || isUnderEvaluation || isEvaluationSubmitted

    return [
      {
        value: TenderTabValues.GENERAL,
        label: t('tenderGeneralInfo'),
        isDisabled: false,
      },
      {
        value: TenderTabValues.QUESTION_ANSWERS,
        label: `${t('questionAndAnswers')}/${t('complaints')}`,
        isDisabled: false,
      },
      {
        value: TenderTabValues.CONTROL_PANEL,
        label: t('control-panel'),
        isDisabled: !isTenderAuthority,
      },
      ...(showCommonSideSections
        ? [
            {
              value: TenderTabValues.REQUIRED_DOCS,
              label: t('required-docs'),
              isDisabled: !isTenderAuthority,
            },
            {
              value: TenderTabValues.EVALUATION,
              label: t('evaluation-tab'),
              isDisabled: !isTenderAuthority,
            },
          ]
        : []),
      ...(isEvaluationSubmitted || isSpecialTenderStatus
        ? [
            {
              value: TenderTabValues.CONTEST_RESULT,
              label: t('contest-result'),
              isDisabled: !isTenderAuthority,
            },
          ]
        : []),
      ...(isSpecialTenderStatus
        ? [
            {
              value: TenderTabValues.FINAL_PROTOCOL,
              label: t('final-protocol'),
              isDisabled: !isTenderAuthority,
            },
          ]
        : []),
    ]
  }, [t, tender])

  return tabs
}
